import React, { Component } from 'react';


export default class SaveButton extends Component {
  render() {
    return (
      <div className={'buttons'}>
        <button className='save-button setting-form' type="submit">
          { this.props.create ? 'Sign Up!' : 'Update' }
        </button>
        { this.props.create &&
        <div style={{ width: '315px' }}>
          By creating an account you agree to our&nbsp;
          <a href='http://www.kegmeisters.com/terms-of-service'>
            Terms of Service&nbsp;
          </a>
          and agree to Stripes Connected Account&nbsp;
          <a href='https://stripe.com/us/connect-account/legal'>
            Terms of Service.
          </a>
        </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Settings/SaveButton.jsx